import { Button } from 'antd';
import React, { useState } from 'react';
import { $Formutil, useForm, withForm } from 'react-antd-formutil';
import { useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Debug from 'components/Debug';
import TelcodePhoneVerify from 'components/forms/TelcodePhoneVerify';
import Toast from 'components/Toast';
import Track from 'components/Track';
import VerifyCodeSend from 'components/VerifyCodeSend';
import { getStep } from 'modules/Security/components/Steps';
import store from 'modules/Security/modules/Modify/store';
import { SecurityActionType } from 'modules/Security/type';
import security from 'stores/security';
import { eventName, eventType, processType } from '../../../helper';

/**
 *  身份验证-短信-Email
 */

export interface VerifyProps {
    $formutil: $Formutil;
    type: SecurityActionType;
    method: 'mail' | 'msg';
}

const VerifyAccount: React.FC<VerifyProps> = ({ type, method }) => {
    const [loading, setLoading] = useState(false);
    const $formutil = useForm();
    const navigate = useNavigate();
    const location = useLocation();

    const submit = async () => {
        const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                const resp = await store.verifySetting(method === 'msg' ? 'phone' : 'email', {
                    process: processType[type],
                    ...$params
                });

                const currentStep = getStep(location.pathname);

                // 需要进行下一步，进行证件号码验证
                if (resp.data.next_step?.includes('id_no')) {
                    // 证件号验证：修改密码时为2，更新密码时为1
                    navigate(`../${currentStep}/id`);
                } else {
                    // 跳转下一步时step：修改密码时为3，更新密码时为2
                    navigate(`../${currentStep + 1}`, { state: { verify_token: resp.data.verify_token } });
                }
            } catch (err) {
                // 操作时长过长
                if (err.error_code === 11084) {
                    navigate('../1');
                }

                Toast.show(err);
            }

            setLoading(false);
        }
    };

    const { $params } = $formutil;
    const { telCode, phone, email } = security.userInfo || {};

    return (
        <div>
            {method === 'msg' ? (
                <>
                    <p>
                        {__('用户手机号')}： +{telCode} {phone}
                    </p>
                    <TelcodePhoneVerify process={processType[type]} logined />
                </>
            ) : (
                <>
                    <p>
                        {__('用户邮箱')}：{email}
                    </p>
                    <VerifyCodeSend type="email" username={email || ''} process={processType[type]} logined />
                </>
            )}
            <CardButtonWrap>
                <Track eventModel="安全中心" eventType={eventType[type]} eventName={`${eventName[type]}_下一步1`}>
                    <Button
                        block
                        type="primary"
                        size="large"
                        className="verify-identify-btn btn-important"
                        onClick={submit}
                        loading={loading}
                        disabled={!$params.verify_code}
                        htmlType="submit">
                        {__('下一步')}
                    </Button>
                </Track>
            </CardButtonWrap>

            <Debug data={$params} />
        </div>
    );
};

export default withForm(VerifyAccount);
